export const defaultTheme = {
    theme: 'acs',
    variables: {
        colorPrimary: '#846cf6',
        colorBackground: '#f5f5f5',
        colorText: '#000000',
        colorGray: {
            primary: '#F5F5F5',
            secondary: '#BFBFBF',
        },
        colorDanger: {
            primary: '#F90215',
            secondary: '#FFECED',
        },
        colorWarning: {
            primary: '#F6851B',
            secondary: '#FFFCF9',
        },
        fontFamily: {
            headline: 'Work Sans, system-ui, sans-serif',
            title: 'Work Sans, system-ui, sans-serif',
            description: 'Work Sans, system-ui, sans-serif',
            text: 'Work Sans, system-ui, sans-serif',
        },
        badgeColor: {
            primary: '#00bcd4',
            secondary: '#ff9800',
            success: '#4caf50',
            warning: '#ff9800',
            danger: '#f44336',
            info: '#2196f3',
            light: '#f4f4f4',
            dark: '#212121',
        },
        borderRadius: '4px',
        boxShadow: '',
        lineBorder: '#DCDCDC',
    },
}
